import React, { useEffect, useState } from "react";
import RightIcon from "../../../../assests/images/Group 911.svg";

const AppInstall = () => {
  const [message, setMessage] = useState("This window will close automatically...");

  useEffect(() => {
    let fromConfig = false;
    try {
      fromConfig = sessionStorage.getItem("shopifyInstallSource") === "config";
    } catch (e) {}

    const hasOpener = (() => {
      try {
        return !!(window.opener && !window.opener.closed);
      } catch (e) {
        return false;
      }
    })();

    // Profile "Complete App Setup" always uses this window name
    const isProfilePopup = window.name === "shopifyAppSetup";

    // Popup / profile flow wins over config-page flag (prevents collision)
    if (hasOpener || isProfilePopup) {
      try {
        sessionStorage.removeItem("shopifyInstallSource");
      } catch (e) {}

      try {
        if (hasOpener) {
          window.opener.postMessage(
            { type: "SHOPIFY_APP_INSTALLED", status: "success" },
            "*",
          );
        }
      } catch (e) {}

      setMessage("This window will close automatically...");
      const closeTimer = setTimeout(() => {
        try {
          window.close();
        } catch (e) {}
      }, 2000);

      return () => clearTimeout(closeTimer);
    }

    // Same-tab flow from /shopify-configuration only
    if (fromConfig) {
      try {
        sessionStorage.removeItem("shopifyInstallSource");
      } catch (e) {}

      setMessage("Redirecting to WatchOps login...");
      const redirectTimer = setTimeout(() => {
        window.location.href = "/login";
      }, 2000);

      return () => clearTimeout(redirectTimer);
    }

    // Fallback: show success and try to close
    setMessage("This window will close automatically...");
    const closeTimer = setTimeout(() => {
      try {
        window.close();
      } catch (e) {}
    }, 2000);

    return () => clearTimeout(closeTimer);
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        fontFamily: "Arial",
        background: "#f9f9f9",
      }}
    >
      <img
        src={RightIcon}
        alt="success"
        width="80"
        style={{ marginBottom: 20 }}
      />

      <h2>WatchOps app setup completed successfully!</h2>
      <p>{message}</p>
    </div>
  );
};

export default AppInstall;
